import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-quant",
  "use": "icon-quant-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-quant\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 1024H0V0h51.2v972.8h972.8v51.2z\" p-id=\"9174\" fill=\"#1296db\" /><path d=\"M0 153.6h409.6v51.2H0zM0 102.4h307.2v51.2H0zM0 256h819.2v51.2H0zM0 204.8h512v51.2H0zM0 358.4h409.6v51.2H0zM0 409.6h512v51.2H0zM0 307.2h716.8v51.2H0zM0 51.2h614.4v51.2H0zM0 563.2h409.6v51.2H0zM0 512h307.2v51.2H0zM0 665.6h921.6v51.2H0zM0 614.4h512v51.2H0zM0 768h409.6v51.2H0zM0 819.2h512v51.2H0zM0 716.8h716.8v51.2H0zM0 460.8h614.4v51.2H0z\" p-id=\"9175\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/quant.svg
// module id = /uaM
// module chunks = 148